// Обновленный frontend/src/AppRoutes.js с добавленным маршрутом для прайсинга

import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import LessonPage from './pages/LessonPage';
import Sandbox from './pages/Sandbox';
import DashboardTabs from './components/dashboard/DashboardTabs';
import MainContent from './components/MainContent';
import Courses from './pages/Courses';
import Demo from './pages/Demo';
import DashboardTabsProto from './pages/proto';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DevTools from './pages/DevTools';
import PricingPage from './pages/PricingPage';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import CourseDetail from './pages/CourseDetail';
import ProtectedRouteWrapper from './pages/ProtectedRouteWrapper';
import CourseConstructor from './pages/CourseConstructor';
import CourseEditor from './pages/CourseEditor';
import { AuthContext } from './App';
import ITSchoolsLanding from './pages/landings/ITSchoolsLanding';
import UniversityLanding from './pages/landings/UniversityLanding';
import AssignmentReviewPage from './pages/AssignmentReviewPage';
import AssignmentLinkAccess from './pages/AssignmentLinkAccess';
import VerifyEmailPage from './pages/VerifyEmailPage';
import PasswordResetConfirmPage from './pages/PasswordResetConfirmPage';
import PresentationPage from './pages/PresentationPage';
import LTIDeepLinkingPage from './pages/LTIDeepLinkingPage';

const AppRoutes = ({
                       handleLoginSuccess,
                       loginOpen,
                       handleCloseLogin,
                       registerOpen,
                       handleCloseRegister,
                       handleRegisterSuccess,
                   }) => {
    const { isAuthenticated, userInfo, token, isLoading } = useContext(AuthContext);

    const onLoginSuccess = async (userToken) => {
        await handleLoginSuccess(userToken);
        // Don't navigate - the store state change will cause App.js to re-render
        // and show the authenticated view automatically
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div
                style={{paddingTop: isAuthenticated ? '75px' : '0'}}
                className="flex w-full"
            >
                <Routes>
                    <Route
                        path="/"
                        element={isAuthenticated ? (
                            <div className="container mx-auto px-4 py-8">
                                <DashboardTabs userInfo={userInfo} token={token}/>
                            </div>
                        ) : (
                            <MainContent/>
                        )
                        }
                    />

                    <Route path="/for-it-schools" element={<ITSchoolsLanding />} />
                    <Route path="/for-universities" element={<UniversityLanding />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/presentation" element={<PresentationPage />} />

                    <Route path="/courses" element={<Courses userInfo={userInfo} />}/>
                    <Route path="/courses/:courseId" element={<CourseDetail userInfo={userInfo} />} />
                    <Route path="/courses/:courseId/lessons/:lessonId" element={
                        <ProtectedRouteWrapper
                            token={token}
                            userInfo={userInfo}
                            component={LessonPage}
                            title="Доступ к уроку ограничен"
                            message="Для просмотра этого урока необходимо войти в систему или зарегистрироваться"
                        />
                    } />

                    <Route
                        path="/sandbox"
                        element={
                            <PrivateRoute>
                                <Sandbox userInfo={userInfo} token={token}/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/sandbox/:sandboxId"
                        element={
                            <ProtectedRouteWrapper
                                token={token}
                                userInfo={userInfo}
                                component={Sandbox}
                                title="Доступ к песочнице ограничен"
                                message="Для доступа к песочнице необходимо войти в систему или зарегистрироваться"
                            />
                        }
                    />
                    <Route
                        path="/course-constructor"
                        element={
                            <PrivateRoute>
                                <CourseConstructor userInfo={userInfo} token={token} />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/courses/:courseId/edit"
                        element={
                            <PrivateRoute>
                                <CourseEditor userInfo={userInfo} token={token} />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/assignments/:id/review"
                        element={
                            <PrivateRoute>
                                <AssignmentReviewPage />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/assignment-link/:token"
                        element={<AssignmentLinkAccess />}
                    />

                    <Route
                        path="/lti/deep-link"
                        element={<LTIDeepLinkingPage />}
                    />

                    <Route path="/demo" element={<Demo/>}/>
                    <Route path="/proto" element={<DashboardTabsProto/>}/>
                    <Route path="/about" element={<About/>}/>
                    <Route path="/contact" element={<Contact/>}/>
                    <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                    <Route path="/terms-of-service" element={<TermsOfService/>}/>
                    <Route path="/devtools" element={
                        userInfo?.is_staff? <DevTools userInfo={userInfo} token={token} /> : <div>This is a restricted area, move along and pretend you didn't see this.</div>
                    }
                    />
                    <Route path="/verify-email" element={<VerifyEmailPage />} />
                    <Route path="/password-reset-confirm" element={<PasswordResetConfirmPage />} />
                    <Route path="*" element={<MainContent/>}/>
                </Routes>
            </div>

            <Dialog open={loginOpen} onClose={handleCloseLogin}>
                <DialogContent>
                    <LoginForm onLoginSuccess={onLoginSuccess} onClose={handleCloseLogin} />
                </DialogContent>
            </Dialog>

            <Dialog open={registerOpen} onClose={handleCloseRegister}>
                <DialogContent>
                    <RegisterForm onRegisterSuccess={handleRegisterSuccess} onClose={handleCloseRegister} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default AppRoutes;
